module.exports = __webpack_public_path__ + "media/images/konintodoke/printout/3-5-1-0a365d899c20d6dadb9d6ba83acdcdd7.png";